import script from "./ResearchPaperAutoFill.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResearchPaperAutoFill.vue?vue&type=script&setup=true&lang=ts"

import "./ResearchPaperAutoFill.vue?vue&type=style&index=0&id=e9c720fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9c720fe"]])

export default __exports__